import instance from "./axios.base";

const getHoroscopes = async () => {
  const res = await instance.get("/horoscope");
  return res.data;
};

export { getHoroscopes };
